export enum IframeId {
  HavikIframe = 'havikIframe', //id of closed domain iframe
  DevEnvIframe = '57003' //id of dev iframe
}
